import { render, staticRenderFns } from "./enTwoCourse.vue?vue&type=template&id=f8803d56&scoped=true&"
import script from "./enTwoCourse.vue?vue&type=script&lang=js&"
export * from "./enTwoCourse.vue?vue&type=script&lang=js&"
import style0 from "./enTwoCourse.vue?vue&type=style&index=0&id=f8803d56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8803d56",
  null
  
)

export default component.exports